<template>
  <div class="news" id="news">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation">{{textData.title}}</div>
          <div class="content animation">{{textData.describe}}</div>
<!--          <el-button class="btn animation">查看更多</el-button>-->
        </div>
      </div>
      <div class="step2" data-step="b">
          <div class="contact-content" >
            <div class="fnt-32-bold animationToBottom">
              {{dataList[0].title}}
            </div>
            <div class="animation" v-show="show1">
              <div class="contact-content-wrap">
                <div class="contact-content-wrap-child" v-for="(item, index) in dataList" :key="index">
                  <div class="item">
                    <div class="contact-content-wrap-child-img">
                      <img :src="item.img"/>
                    </div>
                    <div class="contact-content-wrap-child-title">
                      {{item.tab}}
                    </div>
                  </div>
                  <div class="item">
                    <div v-if="item.phone">
                      <img src="../../../static/images/aboutUs/contactUs/phone.png">
                      {{item.phone}}
                    </div>
                    <div>
                      <img src="../../../static/images/aboutUs/contactUs/email.png">
                      {{item.mail}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="step3" data-step="c">
        <footer-item class="animation"></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../home/components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      textData: {},
      dataList: []
    }
  },
  methods: {
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
      }
    }
  },
  created: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page501.g501[0]
      this.dataList = this.$boss.page514.g514.reverse()
    }
  }
}
</script>
<style scoped lang="less">
.news{
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  div{
    //一级标题
    .first-level-title{
      font-size: 42px;
      font-weight: 500;
      color:#323232;
    }
    //背景图宽度保持不变类
    .bg-img-maintain{
      background-size: cover !important;
      background-position: center !important;
    }
    .head{
      display: flex;
      flex-direction: column;
      align-items: baseline;
      height: 71vh;
      img {
        width: 100%;
        height: 100%;
      }
      .title {
        font-size: 52px;
        opacity: 0;
        margin-top: -45vh;
        font-weight: bold;
        color: #fff;
        padding-left: 100px;
      }

      .content {
        padding-left: 100px;
        font-size: 32px;
        opacity: 0;
        margin-top: 40px;
        color: #E6E9F3;
      }

      .el-button {
        width: 200px;
        height: 60px;
        margin-top: 100px;
        color: #E6E9F3;
        background-color: transparent;
        border: 1px solid #E6E9F3;
        font-size: 18px;
      }
    }
    .contact-content {
      min-height: 747px;
      width: 100%;
      background: url("../../../static/images/aboutUs/contactUs/bg.png") no-repeat;
      background-size: 100% 100%;
      .fnt-title {
        padding: 10px 0;
        font-weight: 700;
      }
      &-wrap {
        padding: 150px 0 50px;
        margin: 0 100px;
        width: calc(100% - 200px);
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        &-child{
          width: 429px;
          height: 459px;
          background: url("../../../static/images/aboutUs/contactUs/content.png") no-repeat;
          background-size: 100% 100%;
          .item:first-child {
            height: 60%;
            border: 1px solid transparent;
          }
          .item:last-child {
            border: 1px solid transparent;
            height: 40%;
            font-size: 20px;
            color: #323232;
            text-align: left;
            margin-top: 5%;
            div {
              padding: 3% 15%;
            }
          }
          &-img {
            margin: 20% auto 0;
          }
          &-title {
            font-size: 20px;
            color: #323232;
            font-weight: 700;
            margin: 5% auto;
          }
        }
        &-child:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/contactUs/index.vue